/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ErpTriggerReason {
    OnMissionClose = '0',
    OnMissionDone = 1,
}
